import type { KeywordsType, ParsedQpStack } from "@quickpoint.me/shared";
/**
 * @module atoms
 * @category State
 */
import { atom, atomFamily } from "recoil";

export const CurrentError = atom<string>({
  key: "CurrentError",
  default: "",
});
// This tracks the type of keyword the cursor is at.
// The hints change based on which ones are relevant to the keyword type
export const CurrentKeyword = atom<KeywordsType | "topLevel" | "init">({
  key: "CurrentKeyword",
  default: "init",
});

/**
 * This tracks if the user has unsaved changes
 */
export const EditorIsClean = atom<boolean>({
  key: "EditorIsClean",
  default: true,
});

export const HostId = atom<string>({
  key: "HostId"
})

export const IsUploading = atom<boolean>({
  key: "IsUploading",
  default: false,
});

export const ParsedStackAtom = atom<ParsedQpStack>({
  key: "ParsedStack",
  default: undefined
})

export type PageLineNumber = { lineNumber: number };
/**
 * an array of each page and the line number it starts on.
 */
export const PageLineNumbers = atom<PageLineNumber[]>({
  key: "PageLineNumbers",
  default: [],
});

export const RenameFamily = atomFamily<boolean, string>({
  key: "RenameFamily",
  default: false,
});


export const PreviewMode = atom<boolean>({
  key: "PreviewMode",
  default: false,
});

export const ReadMode = atom<boolean>({
  key: "ReadMode",
  default: false,
});

/**
 * Base 1: The index of the current page being displayed in the preview panels
 * starts at base 1 rather than base 0
 */
export const ViewerPageIndex = atom<number>({
  key: "ViewerPageIndex",
  default: 1,
});

export const CurrentFilterColorsAtom = atom<any>({
  key: "CurrentFilterColors",
  default: null,
});
